import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import HeroBanner from '../components/HeroBanner';
import CTABanner from '../components/CTABanner';
import { practiceAreas, stats } from '../data';
import './ListingPage.css';

export default function AreaOfPractice() {
  return (
    <>
      <HeroBanner
        title="Our Areas of Practice"
        subtitle="We offer comprehensive paralegal support across multiple practice areas, assisting attorneys with case management, document review, contract support, and legal research to ensure efficient and accurate legal services."
        breadcrumb="Area of Practice"
        ctaText="Explore Services"
        ctaLink="#practice-areas"
      />

      {/* Stats */}
      <section className="stats-bar">
        <div className="container stats-bar__inner">
          {stats.map((stat) => (
            <div key={stat.label} className="stat-item">
              <span className="stat-value">{stat.value}</span>
              <span className="stat-label">{stat.label}</span>
            </div>
          ))}
        </div>
      </section>

      {/* Practice Areas List */}
      <section className="listing-section" id="practice-areas">
        <div className="container">
          <div className="text-center">
            <span className="section-label">Specialized Area of Practice</span>
            <h2 className="section-title">
              Providing comprehensive paralegal services with precision and professionalism
            </h2>
          </div>

          <div className="listing-items">
            {practiceAreas.map((area, i) => (
              <div key={area.slug} className={`listing-item ${i % 2 === 1 ? 'listing-item--reverse' : ''}`}>
                <div className="listing-item__content">
                  <h3>{area.title}</h3>
                  <p>{area.areaDescription}</p>
                  <Link to={`/${area.slug}`} className="btn btn-outline">
                    Learn More <ArrowRight size={16} />
                  </Link>
                </div>
                <div className="listing-item__image">
                  <img src={area.areaImage} alt={area.title} loading="lazy" />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <CTABanner />
    </>
  );
}
